function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#6563FF",
  d: "M8.29 13.29a1 1 0 000 1.42l3 3a1 1 0 001.42 0l3-3a1 1 0 00-1.42-1.42L13 14.59V3a1 1 0 00-2 0v11.59l-1.29-1.3a1 1 0 00-1.42 0zM18 9h-2a1 1 0 000 2h2a1 1 0 011 1v7a1 1 0 01-1 1H6a1 1 0 01-1-1v-7a1 1 0 011-1h2a1 1 0 000-2H6a3 3 0 00-3 3v7a3 3 0 003 3h12a3 3 0 003-3v-7a3 3 0 00-3-3z"
});

var SvgDownloadAlt = function SvgDownloadAlt(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgDownloadAlt;